import { createUseFetcher } from '@brighte/passwordless-authenticator';
import { getConfig } from '@config';

export const useFetcher = createUseFetcher(() => getConfig().url);
